module.exports = __webpack_public_path__ + "img/lanternes-volantes.eb4450a.png";